<template>
    <form-generator :schema="formSchema" :value="value"></form-generator>
</template>

<script>
import HocFormGenerator from '@/components/FormGenerator/HocFormGenerator';
import FormLayout from './SpaceFormLayout';

const FormGenerator = HocFormGenerator(FormLayout);

export default {
    name: 'SpaceReadForm',
    components: {
        'form-generator': FormGenerator
    },
    props: {
        value: {
            type: Object,
            required: false,
            default: () => {}
        }
    },
    computed: {
        formSchema() {
            return [
                {
                    name: 'name',
                    label: 'Room Name'
                },
                {
                    name: 'visibility',
                    label: 'Visibility'
                },
                {
                    name: 'status',
                    label: 'Occupied Status'
                },
                {
                    name: 'building',
                    label: 'Building'
                },
                {
                    name: 'wing',
                    label: 'Wing'
                },
                {
                    name: 'floor',
                    label: 'Floor'
                },
                {
                    name: 'room',
                    label: 'Room Number'
                },
                {
                    name: 'channelMapName',
                    label: 'Channel Lineup'
                },
                {
                    name: 'tags',
                    label: 'Tags',
                    component: {
                        type: 'tags-chip-group',
                        props: {
                            maxDisplayCount: 4,
                            noDataText: '(No tags selected)',
                            itemProps: {
                                small: true
                            }
                        }
                    }
                }
            ];
        }
    }
};
</script>

<style scoped lang="scss"></style>
